const initialState = {
    permisos: {},
    loading: false,
    error: null,
};

export const permisosReducer = (state = initialState, action) => {
    switch (action.type) {
        case "CLEAR_PERMISOS":
            return {
                ...state,
                permisos: {},
                loading: false,
                error: null,
            };
        case "CHECK_PERMISO_REQUEST":
            return {
                ...state,
                loading: true,
            };

        case "CHECK_PERMISO_SUCCESS":
            return {
                ...state,
                loading: false,
                permisos: {
                    ...state.permisos,
                    [action.meta.url]: action.payload
                },
            };

        case "CHECK_PERMISO_FAIL":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};